import React from 'react'
import { Input, Search, Button, Icon, } from "semantic-ui-react";
import { Form as Formiker, Field, withFormik } from 'formik'
import { signInFetchUsers } from "../../redux/actions/loginAction";
import { connect } from "react-redux";
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
const pControl = {
    height: "40px",
    borderRadius: "0px",
    color: "black"
}

const register = () => {
    console.log("in register")
    window.location.href = "/onboard-new-transporter"
}

const Login = ({ errors, touched, isSubmitting }) => (
    <>
        <div className="container">
            <div className="row">
                <div className="col-md-4 col-sm-4 offset-md-4 w3-white w3-card mt-5 w3-round-large">
                    <div className="row">
                        <div className="col-md-4 col-sm-2 mt-5 offset-md-4">
                            <img className="p-1 ml-4" alt="" src="assets/svg/opt_eng.svg" width="60" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-10 col-sm-10 mt-0 offset-md-1">
                            <p className="font-weight-bolder titleName text-center w3-text-blue">Supply Chain Control Tower</p>
                        </div>
                    </div>
                    <Formiker>
                        <div className="row">
                            <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                                <div className="ui form">
                                    <Field name="username" className="input fluid ui" style={pControl} type="text" placeholder="Username" />
                                    {touched.username && errors.username && <small className="p-bold-600 w3-text-red">{errors.username}</small>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1 mt-4">
                                <div className="ui form mt-10">
                                    <Field name="password" className="input fluid ui" style={pControl} type="password" placeholder="Password" />
                                    {touched.password && errors.password && <small className="p-bold-600 w3-text-red">{errors.password}</small>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-10 offset-md-1 col-sm-10 offset-sm-1">
                                <div className="text-center mt-4 ">
                                    <Button type="submit" disabled={isSubmitting} className="fluid primary"><small>Sign In</small></Button>
                                </div>

                                <hr></hr>

                            
                                <div className="ui bottom attached text-center">
                                    <a href='#'  onClick={() => register()}><small>Register</small></a>
                                </div>
                            </div>
                        </div>
                        <br></br>
                    </Formiker>
                </div>
            </div>
        </div>
    </>
)

const FormikLogin = withFormik({
    mapPropsToValues({ username, password }) {
        return {
            username: username || '',
            password: password || ''
        }
    },
    validationSchema: Yup.object().shape({
        username: Yup.string().required('Username Required'),
        password: Yup.string().required('Password Required')
    }),
    handleSubmit(values, { setErrors, setSubmitting, props }) {
        // setSubmitting(true)
        console.log("in handle submit")
        let userName = values.username
        let password = values.password
        props.signInFetchUsers(userName, password).then((response) => {
            let tost = cogoToast.loading('Please wait...')
            // setSubmitting(true)
            tost.then(() => {
                if (response && response.customerNo) {
                    cogoToast.success('Login Successfully')
                    // if (+response.customerNo === 1123 || +response.customerNo === 1158) {
                    //     window.location.href = "/transporter-onboarding"
                    // } else {
                    window.location.href = "/transporter-onboarding"

                    // console.log(props)
                } else {
                    tost.then(() => {
                        cogoToast.error('Invalid username or password')
                        setSubmitting(false)
                    })
                }
            })
        })


    }
})(Login);

export default connect(null, {
    signInFetchUsers
})(FormikLogin)
